import { createContext, createRef, MutableRefObject, useContext } from 'react';

const Layout = createContext<MutableRefObject<number | null>>(createRef());

export const LayoutProvider = ({
  children,
  scrollTopOffset,
}: React.PropsWithChildren<{
  scrollTopOffset: MutableRefObject<number | null>;
}>) => {
  return <Layout.Provider value={scrollTopOffset}>{children}</Layout.Provider>;
};

export const useScrollTopOffset = () => {
  return useContext(Layout);
};

export function findScrollContainer(start: HTMLElement): HTMLElement | Window {
  let node: HTMLElement | null = start.parentElement;

  while (node) {
    const { overflowY } = globalThis.getComputedStyle(node);

    if (
      (overflowY === 'auto' || overflowY === 'scroll') &&
      node.scrollHeight > node.clientHeight
    ) {
      return node;
    }

    node = node.parentElement;
  }

  return globalThis.window;
}

export function scrollByWithLayoutOffset(
  element: HTMLElement,
  offset: number,
  behavior: ScrollBehavior = 'smooth'
) {
  const elementRect = element.getBoundingClientRect();
  const scrollContainer = findScrollContainer(element);

  if (scrollContainer instanceof Window) {
    scrollContainer.scrollBy({
      behavior,
      top: elementRect.top - offset,
    });
    return;
  }

  const containerRect = scrollContainer.getBoundingClientRect();
  const elementTopInContainer = elementRect.top - containerRect.top;

  scrollContainer.scrollBy({
    behavior,
    top: elementTopInContainer - offset,
  });
}
